export abstract class NavbarItem {
    constructor(translate: string) {
        this.translate = translate;
    }

    public get isInPageNavigateNavbarItem(): boolean {
        return this instanceof InPageNavigateNavbarItem;
    }

    public get isSiteUrlNavigateNavbarItem(): boolean {
        return this instanceof SiteUrlNavigateNavbarItem;
    }

    public translate: string;
}

export class InPageNavigateNavbarItem extends NavbarItem {
    constructor(translate: string, scrollToElementId: string) {
        super(translate);
        this.scrollToElementId = scrollToElementId;
    }

    public scrollToElementId: string;
}

export class SiteUrlNavigateNavbarItem extends NavbarItem {
    constructor(translate: string, url: string) {
        super(translate);
        this.url = url;
    }

    public url: string;
}
